import { render, staticRenderFns } from "./Tradutor.vue?vue&type=template&id=7b94e008"
import script from "./Tradutor.vue?vue&type=script&lang=js"
export * from "./Tradutor.vue?vue&type=script&lang=js"
import style0 from "./Tradutor.vue?vue&type=style&index=0&id=7b94e008&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports